/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { signInPath } from 'constants/urls';
import { PrimaryButton } from 'ui';
import s from './styles.module.scss';
import Icon from 'components/core/icon';
import HeaderShared from './layout/header';
import SubTitleShared from './layout/subtitle';

const RegisterSuccess = ({ className = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if this was a WeChat registration by looking at URL parameters
  const searchParams = new URLSearchParams(location.search);
  const isWeChatRegistration = searchParams.get('wechat') === 'true';

  // Get the appropriate success message based on registration type
  const successMessage = isWeChatRegistration ? t('registration_success_info_wechat') : t('registration_success_info');

  return (
    <div className={cx(s.sharedForm, className)}>
      <HeaderShared>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <SubTitleShared>{successMessage}</SubTitleShared>
      <PrimaryButton className={s.sharedFormSubmit} onClick={() => navigate(signInPath)}>
        {t('to_login')}
      </PrimaryButton>
    </div>
  );
};

RegisterSuccess.propTypes = {
  className: PropTypes.string,
};

export default RegisterSuccess;
